// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__font_4c10a2', '__font_Fallback_4c10a2'"},"className":"__className_4c10a2"};